import { Params } from '@angular/router';
import { AlertSeverity } from '../enums/alert-severity.enum';

export enum NotificationBarMessageType {
  LicenseExpiresSoon,
  SchedulerDisabled,
  SchedulerRpaDbNotConnected,
  SchedulerRpaServerNotConnected,
  SchedulerIsSlow,
  LicenseCountInvalid,
  LicenseLimitViolation,
}

export interface NotificationBarMessage {
  type: NotificationBarMessageType;
  tenantId?: string;
  icon: string;
  severity: AlertSeverity;
  htmlText: string;
  tooltip?: string;
  contactSupportEnabled?: boolean;
  link?: {
    text: string;
    route: string[];
    queryParams?: Params;
  };
}
